import { Fragment, useCallback, useEffect, useMemo, useState } from 'react'
import ApplicationCooDashboardLayout from '../layout/application-coo-dashboard-layout';
import { Separator } from '../components/separator';
import { P2Alert, P2EServiceCard, P2Modal } from 'react-bootstrap-common-script';
import { useNavigate } from 'react-router-dom';
import { StatusTrackers } from '../components/status-tracker';
import TrackerItem from '../components/status-tracker/tracker-item/tracker-item';
import { useAppDispatch, useAppSelector } from '../redux/hook';
import { Helpers } from '../utils/helper';
import useGetDashboardAlert from '../hooks/use-get-dashboard-alert';
import { updateProperties } from '../redux/slices/genuine-polymer-slice';
import useCheckHdbProperties from '../hooks/use-check-hdb-properties';
import { ApplicationStart } from '../models/classes/ApplicationStart.class';
import { updateApplicationStartFormDataThunk } from '../redux/slices/application-start-slice';
import { openRouteAddressSelection, openRouteStageD, openRouteStageE, openRouteStartCooApplication } from '../redux/slices/routes-management-slice';
import { resetStageDStates } from '../redux/slices/application-stage-d-slice';
import useCheckSmdByHdbRef from '../hooks/use-check-sms-by-hdb-ref';
import { setShowApplicationCancelled } from '../redux/slices/application-cancelled-slice';
import { API_ApplicationRemove } from '../utils/api';
import { PolymerAxios } from '../utils/axios';
import { setActiveApplications } from '../redux/slices/active-applications-slice';
import config from '../config';
import { uniq } from 'lodash';
import { Properties } from '../models/polymer/Properties.model';
import { LottieLoader } from '../components/loader';
import { updateBb13Applications } from '../redux/slices/bb13-applications-slice';
import useGetBB13ApplicationsByHDBRefs from '../hooks/use-get-bb13-application';
import useIsMobile from '../hooks/use-is-mobile';
import FlatIcon from '../assets/svg/flat-icon';
// import { ApplicationStatusEnum } from '../models/enum/application-status.enum'
function Root() {

  const AppDispatch = useAppDispatch();
  let navigate = useNavigate(); 

  const [isCleared, setCleared] = useState<boolean>(false);
  const [ isInit, setIsInit ] = useState<boolean>(false);
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);
  const loginUserSpcpName = useAppSelector((state) => state.auth.AuthenticationSlice.spcpName);
  const { HdbPropertyData, hasMultipleAddress, singleProperty, noProperty, isIncluded, isLoading: isRdbLoading, isError: isRdbError } = useCheckHdbProperties(loginUser.uinfin, "A");
  const { smsInfo, isLoading, isError, hasOutstandingFees, hasInitiatedApplication } = useCheckSmdByHdbRef(singleProperty ? singleProperty?.hdb_ref : "", "A");
  const [ continueDraftConfirmation, setContinueDraftConfirmation ] = useState<boolean>(false);
  const { ongoingApplications, alertJSX } = useGetDashboardAlert();  
  const startApplicationFormData = useAppSelector(state => state.app.ApplicationStartSlice.formData);
  const showApplicationCancelledAlert = useAppSelector(state => state.app.ApplicationCancelledSlice.show_application_cancelled_alert);
  const existingBb13Applications = useAppSelector(state => state.app.Bb13ApplicationsSlice.bb13Applications);
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);
  const [isMount, setIsMount] = useState(false);
  const [ hasOutstandingFeesModal, setHasOutstandingFeesModal ] = useState<boolean>(false);
  const [ hasApplicationInitiatedModal, setHasApplicationInitiatedModal ] = useState<boolean>(false);
  const [ hasClickInitiateButtonWhenApiLoading, setHasClickInitiateButtonWhenApiLoading ] = useState<boolean>(false);
  
  const [ onlyExistingPop, setOnlyExistingPop] = useState<boolean>(false);
  const [ hasEstateActionCode, setEstateActionCode] = useState<boolean>(false);

  const { isMobile } = useIsMobile();

  const activeApplications = useMemo(() => {
    const nonEligibleStatuses = ["APPLICATION_APPROVED", "APPLICATION_COMPLETED", "APPLICATION_REJECTED", "APPLICATION_CANCELLED", "ARCHIVED", "CANCELLED", "REJECTED", "CLOSED"];
    const filteredOngoingApplications = ongoingApplications?.filter(item => !nonEligibleStatuses.includes(item.application_status)) ?? [];
    return filteredOngoingApplications;
  }, [ongoingApplications])

  const hdbRefList = uniq(HdbPropertyData?.map((item)=> item.hdb_ref));
  
  let { applicationsData: bb13Applications } = useGetBB13ApplicationsByHDBRefs(hdbRefList, activeApplications);
  
  useEffect(() => {
    if(bb13Applications !== undefined){
      AppDispatch(updateBb13Applications(bb13Applications));
    }
  }, [bb13Applications])
  
  useEffect(() => {
    setIsMount(true);
  }, []);

  useEffect(() => {
    if(isMount) {
      return () => {AppDispatch(setShowApplicationCancelled(false))}
    }
  }, [isMount])

  const clearDataAndRoute = useCallback(() =>{
    //RESET
    Helpers.clearPersistData();
    AppDispatch(openRouteStartCooApplication(false));

    //Reset Stage D
    AppDispatch(openRouteStageD(false));
    AppDispatch(resetStageDStates());
    
    //Reset Stage E
    AppDispatch(openRouteStageE(false));
    setCleared(true);
  },[AppDispatch]);
  
  const toPath = useCallback((path:string) =>{ 
    navigate(path);
  },[navigate])

  
 
  useEffect(()=>{
    if(!isCleared){
      clearDataAndRoute();
    }
  },[clearDataAndRoute,isCleared])

  /**
   * Dispatch HDB Properties State from API.
   */
  useEffect(() => {
    if (isCleared && HdbPropertyData) {
      AppDispatch(updateProperties(HdbPropertyData));
    }
  }, [HdbPropertyData, AppDispatch, isCleared])

  /**
   * DO NOT REMOVE;
   * NOTE: This use effect will check if the current user has a multipleAddress, if yes, then open out the route for address selection.
   */
  useEffect(()=>{
    AppDispatch(openRouteAddressSelection(hasMultipleAddress === true));
  },[ hasMultipleAddress ]);

  const navigateToApplication = useCallback((singlePropertyObj:Properties)=>{
    let timeoutId: number;
    timeoutId = window.setTimeout(() => {
      const {address, hdb_ref} = {...singlePropertyObj};
      if(address && hdb_ref){
        setIsInit(false);
        window.location.href = "/transfer/application-coo";
      }
      else{
        setIsInit(false);
        alert("Oops, something wrong with the selected property.");
        navigate("/");
      }
    },1000);
   
    return () => {
      clearTimeout(timeoutId);
    }
  },[navigate])


  const processNewApplication = useCallback(async()=>{
    if(!isLoading){

      let singlePropertyObj = new Properties(singleProperty);
      singlePropertyObj.decryptOwnersOccupiersAdditionalRoles();

      await AppDispatch(updateApplicationStartFormDataThunk({data:new ApplicationStart({ ...startApplicationFormData, has_outstanding_loan: hasOutstandingFees, selected_hdb_property: { ...singlePropertyObj, ...smsInfo } })}))
      
      setIsInit(true);
      
      let timeoutId: number;
      timeoutId = window.setTimeout(() => {
        navigateToApplication(singlePropertyObj);
      },3000);
     
      return () => {
        clearTimeout(timeoutId);
      }
    }
    else{
      console.log("HDB property info is running...");
    }
  },[AppDispatch, hasOutstandingFees, isLoading, navigateToApplication, singleProperty, smsInfo, startApplicationFormData])


  const handleContinueDraftApplication = useCallback(()=>{
    if(activeApplications?.length > 0 && activeApplications[0].application_status !== "CLOSED"){
      const url = `/application-coo?application_id=${activeApplications[0].application_id}`;
      toPath(url);    
    }
    else{
      processNewApplication();
    }
  },[activeApplications, processNewApplication, toPath])

  const processValidateNewApplication = useCallback(()=>{
    if(hasMultipleAddress === false){
      const findBb13Application = existingBb13Applications.find(item => item.hdb_ref.toLowerCase() === singleProperty?.hdb_ref.toLowerCase());
      if(findBb13Application){
          window.location.href = findBb13Application.link;
          return;
      }

      if(activeApplications?.length > 0){
        //1) if when only single address, then has draft, then show prompt
        //2) else when has multiple address, go to property selection page.
        //3) else create a new application
        AppDispatch(openRouteStartCooApplication(true));
        const draftStages = [
          "SAVE_DRAFT",
          "SUBMIT_COMPLETE",
          "GATHER_CONSENT_COMPLETE",
          "PENDING_PAYMENT"
        ]
        if(draftStages.includes(activeApplications[0].application_status)){
          setContinueDraftConfirmation(true);
        }else{
          handleContinueDraftApplication();
        }
      }else{
        processNewApplication();
      }
    }
    else{
      processNewApplication();
    }
  },[AppDispatch, activeApplications, hasMultipleAddress, processNewApplication, existingBb13Applications, singleProperty, handleContinueDraftApplication])
  
  
  const checkIsEstateActionCodeExist = useMemo(()=>{
    const Estate_Action_Code_Enum = ["RS", "OT", "ME", "PT", "AJ", "RP", "SU", "SB", "CI", "SE"];
    
    if(smsInfo && Estate_Action_Code_Enum.includes(smsInfo?.financing_info?.estate_action_code)){
      return true;
    }
    else{
      return false;
    }
    
  },[smsInfo])

  const isRdbStatesReady = useMemo(() => {
    return isIncluded !== undefined && (singleProperty !== undefined || hasMultipleAddress !== undefined || noProperty !== undefined);
  }, [singleProperty, hasMultipleAddress, isIncluded, noProperty])

  const isApiLoading = useMemo(() => {
    return (isLoading || isRdbLoading || !isRdbStatesReady) && !isRdbError;
  }, [isLoading, isRdbLoading, isRdbStatesReady, isRdbError])

  const handleApplicationCooForm = useCallback( async () => {
    if(isApiLoading) {
      setHasClickInitiateButtonWhenApiLoading(true);
      return;
    }

    if(isError) {
      alert("An error occurred. Please try again later.");
    }
    else if(checkIsEstateActionCodeExist){
      setEstateActionCode(true);
    }
    else if(!isIncluded && isError === false){
      setOnlyExistingPop(true);
    }
    else if(noProperty){
      alert("Oops, No property found under this applicant.");
    }
    else if(hasInitiatedApplication === true && !config.allowMultipleApplicationDebug) {
      setHasApplicationInitiatedModal(true);
    }
    else if(hasOutstandingFees === true) {
      setHasOutstandingFeesModal(true);
    }
    else if(hasMultipleAddress){
      window.location.href = "/transfer/application-coo/property-selection";
    }
    else{
      processValidateNewApplication();
    }
    
  },[isLoading, checkIsEstateActionCodeExist, isError, isIncluded, noProperty, hasOutstandingFees, hasInitiatedApplication, hasMultipleAddress, toPath, processValidateNewApplication, singleProperty, isApiLoading]);

  const handleEstimatedFees = () => {
    toPath("/estimate-fees")
  }

  useEffect(() => {
    AppDispatch(setActiveApplications(activeApplications));
  }, [AppDispatch, activeApplications])


  const getDraftApplicationDate = useMemo(()=>{
    if(activeApplications?.length > 0 && activeApplications[0]?.application_create_date){
       return Helpers.formatDate(activeApplications[0].application_create_date);
    }else{
      return '-';
    }

  },[activeApplications])

  const removeApplication = useCallback(async () => {
    const draftStages = [
      "SAVE_DRAFT",
      "SUBMIT_COMPLETE",
      "GATHER_CONSENT_COMPLETE",
      "PENDING_PAYMENT"
    ]
    if(activeApplications?.length > 0 && draftStages.includes(activeApplications[0].application_status)){
      try {
        await PolymerAxios(loginUser?.uinfin ?? "", singpassToken)
          .post(`${API_ApplicationRemove}/${activeApplications[0].application_id}`)
          .then((res) => res.data);
      } catch (error) {
        console.log(error);
      }
    }
  }, [singpassToken, activeApplications, loginUser]);


  const handleContinueDraftButton = useCallback(() => {
    setContinueDraftConfirmation(false);
    handleContinueDraftApplication();
  },[handleContinueDraftApplication])

  const handleCreateNewApplicationButton = useCallback(() => {
    removeApplication();
    processNewApplication();
    setContinueDraftConfirmation(false);
  },[processNewApplication, removeApplication])


  const handleHasOutstandingLoanPopUp = useCallback(()=>{
    setHasOutstandingFeesModal((prev) => !prev)
    processValidateNewApplication();
  },[processValidateNewApplication])

  const closeContinueDraftConfirmationModal = useCallback(() => {
    setContinueDraftConfirmation(false);
  }, [])

  const closeOutstandingFeeModal = useCallback(() => {
    setHasOutstandingFeesModal(false);
  }, [])

  const closeOnlyExistingPopModal = useCallback(() => {
    setOnlyExistingPop(false);
  }, [])
  const closeEstateActionCode = useCallback(() => {
    setEstateActionCode(false);
  }, [])

  const closeHasInitiatedApplicationModal = useCallback(() => {
    setHasApplicationInitiatedModal(false);
  }, [])

  useEffect(() => {
    if(hasClickInitiateButtonWhenApiLoading && !isApiLoading) {
      if(isError) {
        alert("An error occurred. Please try again later.");
        setHasClickInitiateButtonWhenApiLoading(false);
      } else {
        if((singleProperty !== undefined && smsInfo !== undefined) || hasMultipleAddress || noProperty){
          handleApplicationCooForm();
        }
      }
    }
  }, [isApiLoading, hasClickInitiateButtonWhenApiLoading, isError, singleProperty, smsInfo, hasMultipleAddress, noProperty])

  return (
      <ApplicationCooDashboardLayout>
        <p hidden aria-hidden>{process.env.NODE_ENV}</p>
        <div className='polymer-dashboard'>
          <div className='polymer-dashboard__greetings'>
            <p>Hello {loginUserSpcpName === "" ? loginUser.name : loginUserSpcpName}!</p>
          </div>
          {showApplicationCancelledAlert ? <P2Alert style={{marginTop: 32}}  variant={"success"} text={"Application for Change in Flat Ownership has been cancelled."}></P2Alert> : alertJSX}
          <Separator style={{marginTop:53, marginBottom:53}} variant="dashed" title='e-Services'/>
          <div className='polymer-dashboard__eservices'>
            <P2EServiceCard onClick={handleApplicationCooForm} title={<p>Change in Flat Ownership</p>} icon={<FlatIcon size={isMobile ? 58 : 80}/>} style={isMobile ? {minWidth: 160, width: 160, minHeight: 208} : {}}/>
            {config.showEstimateFees ? <P2EServiceCard onClick={handleEstimatedFees} title={<p>Estimate Fees for Change in Flat Ownership</p>} icon={<FlatIcon size={isMobile ? 58 : 80}/>} style={isMobile ? {minWidth: 160, width: 160, minHeight: 208} : {}}/> : null }
            {/* <P2EServiceCard title={"Conversion Scheme"}/>
            <P2EServiceCard title={"Change in Manner of Holding"}/> 
            <P2EServiceCard title={"Financial Planning Calculator"}/> */}
          </div>
          <p style={{display:"none"}}>Application Length - {ongoingApplications?.length}</p>
          {
            ongoingApplications && ongoingApplications.length > 0 && (
              <StatusTrackers>
                {ongoingApplications.slice(0,config.allowMultipleApplicationDebug ? 999 : 3).map((item, index) => {
                  const key = index;
                  const findBb13Application = existingBb13Applications?.find(e => e.hdb_ref === item.hdb_ref && e.status !== "X");
                  return(
                    <Fragment key={key}>
                      <TrackerItem debug={config.allowMultipleApplicationDebug} item={item} itemBB13={findBb13Application}/>
                    </Fragment>
                  )
                })}
                {ongoingApplications.length <= 2 && <TrackerItem />}
                {ongoingApplications.length === 1 && <TrackerItem />}
              </StatusTrackers>
            )
          }
          {
            bb13Applications && bb13Applications.length > 0 && (
              <StatusTrackers>
                {
                  bb13Applications.slice(0,config.allowMultipleApplicationDebug ? 999 : 3).map((item, index) => {
                    const key = index;
                    return(
                      <Fragment key={key}>
                        <TrackerItem debug={config.allowMultipleApplicationDebug} itemBB13={item} />
                      </Fragment>
                    )
                  })
                }
                {bb13Applications.length <= 2 && <TrackerItem />}
                {bb13Applications.length === 1 && <TrackerItem />}
              </StatusTrackers>
            )
          }

          {/*<Separator style={{marginTop:53, marginBottom:53}} variant="dashed" title='Draft Application'/>

          <div className='polymer-status-tracker__content'>
            <div className={`polymer-tracker-item polymer-tracker-item__wrapper`}>
              <div className='polymer-tracker-item__content'>
                <>
                  <p className='polymer-tracker-item__content-title'>Change in Flat Ownership:</p>
                  <p className='polymer-tracker-item__content-description'>Blk 772, #16-145, Bedok Reservoir View, Singapore 319074</p>
                </>
                  <p className='polymer-tracker-item__content-description'>Date of Application: 15 Dec 2022</p>
              </div>
            </div>
            
               <div className={`polymer-tracker-item polymer-tracker-item__wrapper`}>
              <div className='polymer-tracker-item__content'>
                <>
                  <p className='polymer-tracker-item__content-title'>Change in Flat Ownership:</p>
                  <p className='polymer-tracker-item__content-description'>Blk 772, #16-145, Bedok Reservoir View, Singapore 319074</p>
                </>
                  <p className='polymer-tracker-item__content-description'>Date of Application: 15 Dec 2022</p>
              </div>
            </div>
            
               <div className={`polymer-tracker-item polymer-tracker-item__wrapper`}>
              <div className='polymer-tracker-item__content'>
                <>
                  <p className='polymer-tracker-item__content-title'>Change in Flat Ownership:</p>
                  <p className='polymer-tracker-item__content-description'>Blk 772, #16-145, Bedok Reservoir View, Singapore 319074</p>
                </>
                  <p className='polymer-tracker-item__content-description'>Date of Application: 15 Dec 2022</p>
              </div>
            </div>
          </div> */}


          {/* <Separator style={{marginTop:53, marginBottom:53}} variant="dashed" title='FAQs'/>
          <div style={{ maxWidth: "853px", margin: "0 auto" }}>
            <div style={{margin:"20px 0px"}}>
              <P2Accordion defaultOpen={false} title={<p style={{fontWeight:500, fontSize:18, margin: 0 }}>What is Change in Flat Ownership</p>}>
                <div>The EASE programme is part of the Home Improvement Programme (HIP), offered from July 2012. It is also offered separately under EASE (Direct Application). Improvement items installed in your flat through EASE can make it more elderly-friendly, and improve mobility and comfort for elderly residents.</div>
              </P2Accordion>
            </div>
            <div style={{margin:"20px 0px"}}>
              <P2Accordion defaultOpen={false} title={<p style={{fontWeight:500, fontSize:18, margin: 0 }}>How do I change the ownership of my flat?</p>}>
              <div>A change in flat ownership is a conveyancing procedure, similar to that of purchasing an HDB flat. All current and proposed owners must be aware of and give consent to the change in flat ownership.</div>
              <div>This legal process involves the preparation of financial and legal documents. The process typically takes about 4 months, after all applicants have provided their confirmation to proceed with the ownership change and submitted all required documents. A longer processing time may occur for complex cases, such as those which requires lawyer's clarification relating to Court Orders.</div>
              </P2Accordion>
            </div>
            <div style={{margin:"20px 0px"}}>
              <P2Accordion defaultOpen={false} title={<p style={{fontWeight:500, fontSize:18, margin: 0 }}>Who can initiate a change in flat ownership?</p>}>
                <div>Current flat owners may apply to change their flat ownership to include immediate family members who meet all eligibility conditions. If there is more than 1 proposed owner, they would need to decide on the manner of holding the flat upon the ownership change, whether by joint-tenancy, or tenancy-in-common.  A maximum of 4 flat owners can be allowed for each flat. </div>
              </P2Accordion>
            </div>
            <div style={{margin:"20px 0px"}}>
              <P2Accordion defaultOpen={false} title={<p style={{fontWeight:500, fontSize:18, margin: 0 }}>Eligibility</p>}>
                <div>Proposed owners will have to meet these eligibility conditions.</div>
              </P2Accordion>
            </div>
          </div> */}


        </div>
        <P2Modal 
          isOpen={isInit || (hasClickInitiateButtonWhenApiLoading && isApiLoading)}
          children={<LottieLoader/>}
        />
        <P2Modal
          isOpen={continueDraftConfirmation}
          onCloseModal={closeContinueDraftConfirmationModal}
          title={`Create new application`}
          primaryButtonText="No, continue current application"
          secondaryButtonText="Yes, create new application"
          primaryButtonFunction={handleContinueDraftButton}
          secondaryButtonFunction={handleCreateNewApplicationButton}
          children={<p>A draft application was initiated and saved on {getDraftApplicationDate}. Do you want to create a new application?</p>}
        />
        <P2Modal
          isOpen={hasOutstandingFeesModal}
          onCloseModal={closeOutstandingFeeModal}
          variant="default"
          title={`You having outstanding fee(s)`}
          primaryButtonText="Acknowledge"
          primaryButtonFunction={handleHasOutstandingLoanPopUp}
          children={<p>Please note that you have outstanding fees owing to HDB. Please make the necessary payments before initiating a change in flat ownership application.</p>}
        />
        <P2Modal
          isOpen={onlyExistingPop}
          onCloseModal={closeOnlyExistingPopModal}
          variant="default"
          title={`You are not eligible to proceed.`} 
          primaryButtonText="Back"
          primaryButtonFunction={() => setOnlyExistingPop(false)}
          children={<><p>Only existing flat owner(s) can submit the request for the change in flat ownership. For more information, you may refer to this page on <a className="polymer-text-links" href="https://www.hdb.gov.sg/cs/infoweb/residential/living-in-an-hdb-flat/changing-owners-occupiers/change-in-ownership/change-in-flat-ownership">Change in Flat Ownership</a>.</p></>}
        />
        <P2Modal
          isOpen={hasEstateActionCode}
          onCloseModal={closeEstateActionCode}
          variant="default"
          title={`You cannot start a new application.`} 
          children={<><p>There is another ongoing transaction for the flat, you will not be able to submit a change in flat ownership application.</p></>}
        />
        <P2Modal
          isOpen={hasApplicationInitiatedModal}
          onCloseModal={closeHasInitiatedApplicationModal}
          variant="default"
          title={`This property has been initiated by other applicant`}
          primaryButtonText="Acknowledge"
          primaryButtonFunction={closeHasInitiatedApplicationModal}
          children={<p>Please note that this property has been initiated by other applicant.</p>}
        />
      </ApplicationCooDashboardLayout>
  );
}

export default Root